function isTownsDomain(hostname: string): boolean {
    return hostname === 'app.towns.com' || hostname === 'fast-app.towns.com'
}

// matches subdomains of towns.com, ie. app.towns.com, beta.towns.com, etc.
// we could harden this by checking for a specific list of subdomains but the
// main purpose is a preemptive check to avoid parsing URLs that are not towns
const domainRegex = /\.towns\.com$/

const hostname = import.meta.env.DEV
    ? // shortcut for debugging, mapping this to ENVs would add unnecessary overhead on production
      'app.towns.com'
    : new URL(window.location.href).hostname

export const isTownsAppUrl = (url: URL): boolean => {
    try {
        return (
            // handle the url in the same window if it's a towns app domain (in any env)
            // AND url.hostname is identical to the current hostname (support app.beta.towns.com etc)
            // OR, if the current hostname is `app.towns.com` AND the url is `fast-app.towns.com` (or vice versa).
            // This way links to fast-app.towns.com will be handled in the same window as app.towns.com,
            // while links to app.towns.com/fast-app.towns.com will open a new window if the current
            // hostname is beta etc.
            domainRegex.test(url.hostname) &&
            (url.hostname === hostname || (isTownsDomain(hostname) && isTownsDomain(url.hostname)))
        )
    } catch (e) {
        return false
    }
}

export const isTownsAppUrlString = (url: string) => {
    try {
        const parsedUrl = new URL(url)
        return isTownsAppUrl(parsedUrl)
    } catch (e) {
        return false
    }
}
